(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["origin-recipe-tag-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('origin-recipe-tag-navigation')) {
    customElements.define('origin-recipe-tag-navigation', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.row = this.querySelector('[data-topic-row]');
        this.list = this.querySelector('[data-topic-list]');
        this.overflow = this.querySelector('[data-topic-overflow]');
        this.toggle = this.querySelector('[data-topic-toggle]');
        if (!this.row || !this.list || !this.overflow || !this.toggle) return;
        this.items ||= Array.from(this.list.children);
        this.onResize = () => this.scheduleLayout();
        this.onToggle = () => this.setExpanded(this.overflow.hidden);
        this.onKeyDown = event => {
          if (event.key === 'Escape' && !this.overflow.hidden) {
            event.preventDefault();
            this.setExpanded(false);
            this.toggle.focus({ preventScroll: true });
          } else if (event.key === 'ArrowDown' && event.target === this.toggle) {
            event.preventDefault();
            this.setExpanded(true);
            this.overflow.querySelector('a')?.focus({ preventScroll: true });
          }
        };
        this.toggle.addEventListener('click', this.onToggle);
        this.addEventListener('keydown', this.onKeyDown);
        document.fonts?.addEventListener('loadingdone', this.onResize);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(entries => {
            const width = entries[0].contentRect.width;
            if (width === this.observedWidth) return;
            this.observedWidth = width;
            this.scheduleLayout();
          });
          this.observer.observe(this.row);
        } else {
          window.addEventListener('resize', this.onResize);
        }
        this.setAttribute('data-enhanced', '');
        this.layout();
        document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleLayout(); });
      }
      scheduleLayout() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => { if (this.isConnected) this.layout(); });
      }
      setExpanded(expanded) {
        const open = expanded && !this.toggle.hidden && this.overflow.children.length > 0;
        if (!open && this.overflow.contains(document.activeElement)) this.toggle.focus({ preventScroll: true });
        this.toggle.setAttribute('aria-expanded', String(open));
        this.toggle.setAttribute('aria-label', open ? this.toggle.dataset.lessLabel : this.toggle.dataset.moreLabel);
        this.overflow.hidden = !open;
      }
      layout() {
        const width = this.row.clientWidth;
        if (!width || !this.items?.length) return;
        const focused = this.contains(document.activeElement) ? document.activeElement : null;
        const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
        for (const item of this.items) {
          item.style.maxInlineSize = '';
          this.list.append(item);
        }
        this.toggle.hidden = false;
        const widths = new Map(this.items.map(item => [item, item.getBoundingClientRect().width]));
        const gap = parseFloat(getComputedStyle(this.list).gap) || 8;
        const total = this.items.reduce((sum, item) => sum + widths.get(item), 0) + gap * (this.items.length - 1);
        if (total <= width) {
          this.toggle.hidden = true;
        } else {
          const available = Math.max(0, width - this.toggle.getBoundingClientRect().width - gap);
          const first = this.items[0];
          const selected = this.items.slice(1).find(item => item.dataset.selected === 'true');
          const firstWidth = Math.min(widths.get(first), selected ? available - gap - Math.min(widths.get(selected), 72) : available);
          first.style.maxInlineSize = `${Math.max(0, firstWidth)}px`;
          const visible = [first];
          let used = firstWidth;
          if (selected) {
            const selectedWidth = Math.max(0, Math.min(widths.get(selected), available - used - gap));
            selected.style.maxInlineSize = `${selectedWidth}px`;
            visible.push(selected);
            used += selectedWidth + gap;
          }
          for (const item of this.items) {
            if (visible.includes(item)) continue;
            if (used + gap + widths.get(item) > available) break;
            visible.push(item);
            used += gap + widths.get(item);
          }
          for (const item of visible) this.list.append(item);
          for (const item of this.items) if (!visible.includes(item)) this.overflow.append(item);
        }
        this.setExpanded(expanded);
        if (focused) {
          if (this.list.contains(focused) || (!this.overflow.hidden && this.overflow.contains(focused))) focused.focus({ preventScroll: true });
          else if (!this.toggle.hidden) this.toggle.focus({ preventScroll: true });
          else this.items[0].querySelector('a')?.focus({ preventScroll: true });
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        if (!this.onResize) return;
        window.removeEventListener('resize', this.onResize);
        document.fonts?.removeEventListener('loadingdone', this.onResize);
        this.toggle?.removeEventListener('click', this.onToggle);
        this.removeEventListener('keydown', this.onKeyDown);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    (() => {
    const buttonSelector = '.mailchimp-for-shopify-product-block .back-in-stock-btn';

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest(buttonSelector)) return;

      let attempts = 0;
      const tickWhenReady = () => {
        if (window._mcfq && typeof window._mcfq.tick === 'function') {
          window._mcfq.tick();
          return;
        }

        attempts += 1;
        if (attempts < 50) window.setTimeout(tickWhenReady, 100);
      };

      window.setTimeout(tickWhenReady, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
